import React, { useState } from "react";
import SubscriptionCard from "../../Components/subscription/SubscriptionCard";
import SubscriptionsTable from "../../Components/subscription/SubscriptionsTable";
import CreditNoteCard from "../../Components/creditNote/CreditNoteCard";
import CreditNoteTable from "../../Components/creditNote/CreditNoteTable";

const CreditNote = () => {
    //#region code
    const [isChanged, setIsChanged] = useState(false);
    const [editData, setEditData] = useState(null);

    const handleEdit = (params) => {
        const data = {
            id: params.id,
            customer_id: params.customer_id,
            invoice_id: params.invoice_id,
            credit_note_date: params.credit_note_date,
            reason: params.reason,
            tax_type: params.tax_type,
            include_gst: Boolean(params.include_gst),
            status: Boolean(params.status),
            taxable_value: params.taxable_value,
            tax_amount: params.tax_amount,
            total_amount: params.total_amount,
            products: params.items
        };
        setEditData(data);
    }

    //#endregion

    return (
        <>
            <CreditNoteCard editData={editData} setEditData={setEditData} isChanged={isChanged} setIsChanged={setIsChanged}/>
            <CreditNoteTable isChanged={isChanged} handleEdit={handleEdit} />
        </>
    )
};
export default CreditNote;